export default __webpack_public_path__ + "static/media/frame4.c926f81a.webp";